import { fromNewCodeDataList } from './NewCodeData.js';
import { mapDtoList, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.generator.common.codes.CodeSuggest
 *
 * @typedef {object} CodeSuggestData
 * @property {string|null} phrase
 * @property {import('./NewCodeData.js').NewCodeData[]} suggestions
 */

/**
 * @param {object} raw
 * @returns {CodeSuggestData}
 */
export function fromCodeSuggestData(raw) {
  const source = requireObject(raw, 'CodeSuggest');
  return {
    phrase: optionalString(source.phrase),
    suggestions: fromNewCodeDataList(source.suggestions),
  };
}

/**
 * @param {unknown} raw
 * @returns {CodeSuggestData[]}
 */
export function fromCodeSuggestDataList(raw) {
  return mapDtoList(raw, 'CodeSuggest', fromCodeSuggestData);
}
